/**
 * Created by razial on 07.11.2022
 */

cleverapps.overrideStyles(cleverapps.styles.Decorators, {
    "xmas_window_right_bottom": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "down_right",
        x: { align: "right", dx: 17 },
        y: { align: "bottom", dy: -19 },
        lovesBackgroundAndForeground: true
    },

    "xmas_window_left_top": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "up_left",
        x: { align: "left", dx: -24 },
        y: { align: "top", dy: 19 },
        lovesBackgroundAndForeground: true
    },

    "xmas_window_left_top_bgonly": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "up_left",
        x: { align: "left", dx: -18 },
        y: { align: "top", dy: 16 },
        lovesBackground: true
    },

    "xmas_window_snowfall": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window_snowfall,
        animation: "animation",
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        zOrder: -1,
        lovesWindow: true
    },

    "halloween_window_candle_right": {
        json: bundles.windows.jsons.candle_json,
        type: Decors.TYPE_ANIMATION,
        animation: "animation",
        x: { align: "right", dx: 97 },
        y: { align: "top", dy: -82 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_candle_left": {
        json: bundles.windows.jsons.candle_json,
        type: Decors.TYPE_ANIMATION,
        animation: "animation",
        x: { align: "left", dx: -97 },
        y: { align: "top", dy: -82 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: -1,
            y: 1
        }
    },

    "halloween_window_lian_left": {
        image: bundles.windows.frames.lian_down_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: -17 },
        y: { align: "top", dy: -286 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_top": {
        image: bundles.windows.frames.lian_left_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: -4 },
        y: { align: "top", dy: 35 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_right": {
        image: bundles.windows.frames.lian_left_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: 63 },
        y: { align: "top", dy: -300 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        },
        rotation: 90
    },

    "halloween_window_lian_bottom": {
        image: bundles.windows.frames.lian_right_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: -70 },
        y: { align: "bottom", dy: -24 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: -1,
            y: -1
        }
    },

    "halloween_window_pumpkin": {
        image: bundles.windows.frames.pumpkin_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: -300 },
        y: { align: "top", dy: 132 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_spider": {
        image: bundles.windows.frames.spider_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 3 },
        y: { align: "bottom", dy: 6 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SceneDecors, {
    xmas_menubar: {
        image: bundles.menubar.frames.xmas_menubar,
        x: { align: "left", dx: 25 },
        y: { align: "top", dy: 17 }
    },

    halloween_menubar_level: {
        image: bundles.menubar.frames.spiderweb_decor,
        x: { align: "right", dx: -10 },
        y: { align: "top", dy: -10 }
    },

    halloween_menubar: {
        image: bundles.menubar.frames.spiderweb_decor,
        x: { align: "right", dx: -4 },
        y: { align: "top", dy: -2 }
    }
});
